import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
// Composants
import App from './App';
import ErrorBoundary from './components/Utils/ErrorBoundary';
// Librairies
import * as Sentry from '@sentry/react';
// Redux
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
// Semantic UI
import 'semantic-ui-css/semantic.min.css';
// Styles
import './styles/index.css';

const middleware = [thunk];
const store = createStore(rootReducer, applyMiddleware(...middleware));

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <ErrorBoundary isGlobal={true}>
            <App />
        </ErrorBoundary>
    </Provider>
);

// Offline mode
serviceWorker.register();